import { Button, Empty, Flex, List, Popconfirm, Space, Tag, Typography, theme } from 'antd';
import { FC, ReactElement, useState } from 'react';
import { ExclamationCircle, PersonVcard, Trash } from 'react-bootstrap-icons';

import { CopyableText } from '@/common/components';

import { HostingAccount, HostingsAccountHiddenPassword } from '@/modules/Hostings';

interface Props {
  hostingAccountsDataSource: HostingAccount[];
  disableControlButtons: boolean;
  handleDeleteAccount: (accountId: string) => void;
}

const { Text } = Typography;

export const HostingAccountsListView: FC<Props> = ({ hostingAccountsDataSource, disableControlButtons, handleDeleteAccount }) => {
  const { token } = theme.useToken();
  const [editableRowKey, setEditableRowKey] = useState<string | null>(null);

  return (
    <div style={{ overflowY: 'auto', maxHeight: 760, marginInline: -24, paddingInline: 24 }}>
      <List
        className="app-list"
        dataSource={hostingAccountsDataSource}
        locale={{
          emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Немає акаунтів" />,
        }}
        header={
          <div
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              position: 'sticky',
            }}
          >
            <Text strong>
              Доступи до хостинга <Tag color="blue">{hostingAccountsDataSource.length}</Tag>
            </Text>
            {<PersonVcard size={22} />}
          </div>
        }
        renderItem={(item): ReactElement => (
          <List.Item
            extra={
              <Space size="small">
                {/* <Button
                  type="text"
                  disabled={ disableControlButtons }
                  onClick={ (): void => setEditableRowKey(item.id) }
                  icon={ <Pencil/> }
                /> */}
                <Popconfirm
                  destroyTooltipOnHide
                  title="Видалити акаунт"
                  icon={<ExclamationCircle color={token.colorError} />}
                  description="Ви дійсно хочете видалити цей акаунт?"
                  onConfirm={(): void => handleDeleteAccount(item.id)}
                  okText="Так, видалити"
                  okButtonProps={{ danger: true }}
                  cancelText="Ні"
                  placement="topLeft"
                  disabled={disableControlButtons}
                >
                  <Button type="text" danger disabled={disableControlButtons} icon={<Trash />} />
                </Popconfirm>
              </Space>
            }
          >
            <List.Item.Meta
              title={
                <>
                  <Text type="secondary" style={{ fontWeight: 400, wordBreak: 'keep-all' }}>
                    Логін:&nbsp;
                  </Text>
                  <CopyableText textToCopy={item.login} style={{ maxWidth: 265, width: '100%' }}>
                    {item.login}
                  </CopyableText>
                  <br />
                  <Flex align="center" wrap={false}>
                    <Text type="secondary" style={{ fontWeight: 400, wordBreak: 'keep-all' }}>
                      Пароль:&nbsp;
                    </Text>
                    <HostingsAccountHiddenPassword hostingId={item.hostingId} hostingAccountId={item.id} />
                  </Flex>
                </>
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
};
